import type { BetslipApplicationState } from "../BetslipApplicationState";
import { PotentialBetState } from "./ExchangeBettingPotential.types";
import type { ExchangeSide } from "../../../types";

export const getExchangePotentialState = (
  state: BetslipApplicationState,
  runner: string,
  side: ExchangeSide,
): PotentialBetState | undefined => {
  const runnerPotentialBets = state.exchangeBettingPotential?.[runner];
  return side === "BACK" ? runnerPotentialBets?.back : runnerPotentialBets?.lay;
};
